<template>
  <v-app id="inspire">
    
      <v-container
        class="fill-height"
        fluid
      >
        <v-row
          align="center"
          justify="center"
        >
          <v-col
            cols="12"
            sm="8"
            md="4"
          >
            <v-card class="elevation-12">
              <v-toolbar
                color="primary"
                dark
                flat
              >
                <v-toolbar-title>Login form</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-form  ref="form">
                <v-card-text>
                  
                    <v-text-field
                      label="User Name"
                      name="login"
                      prepend-icon="mdi-account"
                      v-model="logininput.user"
                      type="text"
                    ></v-text-field>

                    <v-text-field
                      id="password"
                      label="Password"
                      name="password"
                      prepend-icon="mdi-lock"
                      v-model="logininput.pass"
                      type="password"
                    ></v-text-field>
                  
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" @click="login()">
                    <span v-if="!loadingLogin">Login</span>
                    <v-progress-circular v-else-if="loadingLogin"
                      indeterminate
                      color="white"
                      size="20"
                      width="3"
                    ></v-progress-circular>

                  </v-btn>
                </v-card-actions>
              </v-form>
            </v-card>
          </v-col>
        </v-row>
         

      </v-container>
    
  </v-app>
</template>

<script>

import { mapActions, mapState } from 'vuex';

  export default {
    name:'formlogin',
    data(){
      return {
        logininput:{
          user:'',
          pass:''
        },
        loadingLogin: false,
        

      };
    },

    created() {
        
        console.log('fsfdsf');
    },

    computed:{
      ...mapState(['API_URL']),
      
    },
    methods :{
      ...mapActions('login', ['getlogin']),
      alertNotif(title, type, text) {
        this.$swal({
          heightAuto: false,
          title,
          type,
          text,
        });
    },
      login(){
        
        if (this.logininput.user!='' && this.logininput.pass!=''){
            const param = new FormData();
            param.append('user',this.logininput.user);
            param.append('pass',this.logininput.pass);
            this.getlogin(param).then((res)=>{
              if (res.success){
                 this.$cookies.set('user', this.logininput.user );
                  this.$cookies.set('statususer', '1');
                  this.$cookies.set('emailuser', res.data._email);
                  this.$router.push('/');
              }else{
                this.alertNotif('Login', 'warning', 'Cek kembali user dan password anda !');

              }
            });
            // if (this.logininput.user=='admin' && this.logininput.pass=='admin'){
            //   console.log ('berhasil logijn');
            //   this.$cookies.set('user', this.logininput.user );
              
            //   this.$cookies.set('statususer', '1');
            //     // this.$router.replace('/');
            //     this.$router.push('/');

            // }else{
            //   // this.snackbarer = true
            //   // this.dialogMessage = "Cek kembali user dan password anda!"
            //   this.alertNotif('Login', 'warning', 'Cek kembali user dan password anda !');
            // }
        }else{
            this.$swall
          // this.snackbarer = true
          // this.dialogMessage = "Username dan Password harus diisi !"
            this.alertNotif('Failure', 'warning', 'Username dan Password harus diisi !');
        }
      },

    },



  }
</script>